// package: coconala.protobuf.gw.servicepr
// file: gw/servicepr/service_pr.proto

import * as gw_servicepr_service_pr_pb from "../../gw/servicepr/service_pr_pb";
import * as google_protobuf_wrappers_pb from "google-protobuf/google/protobuf/wrappers_pb";
import * as domain_enumeration_service_pr_payment_type_pb from "../../domain/enumeration/service_pr_payment_type_pb";
export class ServicePrService {
  static serviceName = "coconala.protobuf.gw.servicepr.ServicePrService";
}
export namespace ServicePrService {
  export class GetLatest {
    static readonly methodName = "GetLatest";
    static readonly service = ServicePrService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = gw_servicepr_service_pr_pb.GetLatestRequest;
    static readonly responseType = gw_servicepr_service_pr_pb.GetLatestResponse;
  }
  export class Publish {
    static readonly methodName = "Publish";
    static readonly service = ServicePrService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = gw_servicepr_service_pr_pb.PublishRequest;
    static readonly responseType = gw_servicepr_service_pr_pb.PublishResponse;
  }
  export class Stop {
    static readonly methodName = "Stop";
    static readonly service = ServicePrService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = gw_servicepr_service_pr_pb.StopRequest;
    static readonly responseType = gw_servicepr_service_pr_pb.StopResponse;
  }
  export class ChangeDailyBudget {
    static readonly methodName = "ChangeDailyBudget";
    static readonly service = ServicePrService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = gw_servicepr_service_pr_pb.ChangeDailyBudgetRequest;
    static readonly responseType = gw_servicepr_service_pr_pb.ChangeDailyBudgetResponse;
  }
  export class Initialize {
    static readonly methodName = "Initialize";
    static readonly service = ServicePrService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = gw_servicepr_service_pr_pb.InitializeRequest;
    static readonly responseType = gw_servicepr_service_pr_pb.InitializeResponse;
  }
  export class ChangePaymentType {
    static readonly methodName = "ChangePaymentType";
    static readonly service = ServicePrService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = gw_servicepr_service_pr_pb.ChangePaymentTypeRequest;
    static readonly responseType = gw_servicepr_service_pr_pb.ChangePaymentTypeResponse;
  }
  export class GetPaymentType {
    static readonly methodName = "GetPaymentType";
    static readonly service = ServicePrService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = gw_servicepr_service_pr_pb.GetPaymentTypeRequest;
    static readonly responseType = gw_servicepr_service_pr_pb.GetPaymentTypeResponse;
  }
}
